import { PropsWithChildren } from 'react';
import { Layout, Button, Space, Tag, Menu } from 'antd';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import {
  GlobalOutlined,
  MoonOutlined,
  SunOutlined,
  LoginOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { useEnvLabel } from '../util/useEnvLabel.js';
import { useI18n } from '../i18n.js';
import { useTheme } from '@digiwedge/ui-theme';

const { Header, Content, Footer } = Layout;

function useActiveKey() {
  const { pathname } = useLocation();
  if (pathname === '/' || pathname.startsWith('/home')) return ['/home'];
  if (pathname.startsWith('/scanner')) return ['/scanner'];
  if (pathname.startsWith('/health')) return ['/health'];
  return [] as string[];
}

export default function PublicShell(_props: PropsWithChildren) {
  const navigate = useNavigate();
  const env = useEnvLabel();
  const active = useActiveKey();
  const { mode, toggleTheme } = useTheme();
  const { language, setLanguage, direction } = useI18n();

  return (
    <Layout style={{ minHeight: '100vh' }} dir={direction}>
      <Header style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          className="text-white font-semibold"
          style={{ marginRight: 16, cursor: 'pointer' }}
          onClick={() => navigate('/home')}
        >
          CMP
        </div>

        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={active}
          onClick={(e) => navigate(String(e.key))}
          items={[
            { key: '/home', label: 'Home' },
            { key: '/scanner', label: 'Scanner' },
            { key: '/health', label: 'Health' },
          ]}
          style={{ flex: 1, minWidth: 0 }}
        />

        <Space>
          <Tag color={env.color}>{env.label}</Tag>

          <Button
            type="text"
            aria-label="Toggle theme"
            onClick={toggleTheme}
            icon={mode === 'dark' ? <SunOutlined /> : <MoonOutlined />}
          />

          <Button
            type="text"
            aria-label="Switch language"
            icon={<GlobalOutlined />}
            onClick={() => setLanguage(language === 'en' ? 'ar' : 'en')}
          >
            {language === 'en' ? 'العربية' : 'EN'}
          </Button>

          <Button onClick={() => navigate('/login')} icon={<LoginOutlined />}>
            Log in
          </Button>
          <Button type="primary" onClick={() => navigate('/signup')} icon={<UserAddOutlined />}>
            Sign up
          </Button>
        </Space>
      </Header>

      <Content style={{ padding: 24 }}>
        <Outlet />
      </Content>

      <Footer style={{ textAlign: 'center', opacity: 0.8 }}>
        © {new Date().getFullYear()} CMP · Consent Mode v2 • GPC • i18n • Multi-tenant
      </Footer>
    </Layout>
  );
}
